import { getUserDetails, getUserGroupList } from "@/common/service/userService.js";
import { constants } from "@/lib/CONSTANTS.js";

const state = {
  loginDetails: {},
  userGroupDetails: [],
  userDetails: null,
  userDetailsError: null,
  groupId: null,
  isAuthenticated: false,
  isGroupIdSet: null
};

const getters = {
  getLoginDetails: state => {
    const { name, userName, idTokenClaims } = state.loginDetails;
    return { name, userName, idTokenClaims };
  }
};

const mutations = {
  setLoginDetails(state, value) {
    state.loginDetails = value;
  },
  setUserDetails(state, value) {
    state.userDetails = value;
  },
  setGroupId(state, value) {
    state.groupId = value;
  },
  setUserGroupDetails(state, value) {
    state.userGroupDetails = value;
  },
  setAuthentication(state, value) {
    state.isAuthenticated = value;
  },
  setGroupIdFound(state, value) {
    state.isGroupIdSet = value;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  }
};

const actions = {
  hasAuthenticated({ commit }, data) {
    commit("setAuthentication", data.isAuthenticated);
    commit("setLoginDetails", data.loginDetails);
  },

  async getGroupDetails({ commit }) {
    try {
      let userGroupDetails = state.userGroupDetails;
      if (userGroupDetails.length < 1) {
        userGroupDetails = await getUserGroupList();
        for (const item of userGroupDetails) {
          let tempItem = {};
          tempItem.value = item.id;
          tempItem.label = item.teamName;
          constants.pageSettings.exception.filters.groupFilterDropdown.push(tempItem);
        }
        commit("setUserGroupDetails", userGroupDetails);
      }
    } catch (error) {
      commit("setUserGroupDetails", []);
    }
  },
  async getUserDetails({ commit, state }) {
    try {
      let userDetails = state.userDetails;
      if (!userDetails) {
        userDetails = await getUserDetails(state.loginDetails?.userName);
        commit("setUserDetails", userDetails);
        if (userDetails.groupId) {
          commit("setGroupId", userDetails.groupId);
        }
        commit("setGroupIdFound", true);
      }
      commit("setErrorState", { type: "userDetails", error: "" });
    } catch (error) {
      commit("setUserDetails", null);
      commit("setGroupIdFound", false);
      commit("setErrorState", { type: "userDetails", error });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
